import React, { useEffect } from "react";
import "./info.css";
import { data } from "../../assets/data";
import AOS from "aos";
import "aos/dist/aos.css";

const Info = () => {
  useEffect(() => {
    AOS.init({ duration: 400 });
  }, []);
  return (
    <div className="my-5 container">
      <div className="row info-row">
        <div
          data-aos="fade-down"
          data-aos-offset="100"
          data-aos-easing="ease-in-sine"
          className="col-sm-6 col-xl-3 info-items"
        >
          <img src={data[0]?.image} alt={data[0]?.title} />
          <h6> {data[0]?.title} </h6>
        </div>
        <div
          data-aos="fade-down"
          data-aos-offset="100"
          data-aos-easing="ease-in-sine"
          className="col-sm-6 col-xl-3 info-items"
        >
          <img src={data[1]?.image} alt={data[0]?.title} />
          <h6> {data[1]?.title} </h6>
        </div>
        <div
          data-aos="fade-up"
          data-aos-offset="100"
          data-aos-easing="ease-in-sine"
          className="col-sm-6 col-xl-3 info-items"
        >
          <img src={data[2]?.image} alt={data[0]?.title} />
          <h6> {data[2]?.title} </h6>
        </div>
        <div
          data-aos="fade-up"
          data-aos-offset="100"
          data-aos-easing="ease-in-sine"
          className="col-sm-6 col-xl-3 info-items"
        >
          <img src={data[3]?.image} alt={data[0]?.title} />
          <h6> {data[3]?.title} </h6>
        </div>
      </div>
    </div>
  );
};

export default Info;
